import React from "react";
import HeroSection from "../components/sections/HeroSection";
import Marquee from "../components/Marquee";
import IntroSection from "../components/sections/IntroSection";
import ArtistsSection from "../components/sections/ArtistsSection";
import ServicesSection from "../components/sections/ServicesSection";
import GuestCTASection from "../components/sections/GuestCTASection";
import LocationSection from "../components/sections/LocationSection";
import ContactSection from "../components/sections/ContactSection";

const Home = () => {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <Marquee />
      <IntroSection />
      <ArtistsSection />
      <ServicesSection />
      <GuestCTASection />
      <LocationSection />
      <ContactSection />
    </main>
  );
};

export default Home;
